import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../Appstore/store';

const Loader: React.FC = () => {
    const isLoading = useSelector((state: RootState) => state.loading.isLoading);

    return (
        <>
            {isLoading && (
                <div className="spinner">
                    <div className="spinner-container">
                        <div className="spinner-loader"></div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Loader;
